// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/**
 * Feature flags for the Advisor UI
 *
 * These flags control experimental or optional features.
 * Set to true to enable a feature, false to disable.
 */

export const featureFlags = {
  /**
   * Enable the "Save Draft" button in the profile wizard.
   * When disabled, the draft functionality is hidden from users
   * but auto-save to localStorage still works in the background.
   */
  enableWizardSaveDraft: false,

  /**
   * Enable the "Support Team" menu item in the sidebar.
   * When disabled, the Support Team page is not accessible from the menu.
   */
  enableSupportTeamMenu: false,

  /**
   * Enable the global Advisor Companion (Fin) launcher. Renders on
   * every authenticated route. Replaces the legacy `enableFundChatbot`
   * gate. The launcher creates sessions against the
   * `ADVISOR_COMPANION` use case (V16 Flyway).
   *
   * Backend gate: intelligence-service must have the
   * `ADVISOR_COMPANION` use case enabled (ships enabled by default).
   * Per-brokerage opt-out via `chat_settings.enabled=false`.
   */
  enableAdvisorCompanion: true,

  /**
   * Legacy alias for {@link enableAdvisorCompanion}. Kept for one
   * release so any code that referenced the old flag keeps working;
   * remove on the next release once import sites are updated.
   *
   * @deprecated Use `enableAdvisorCompanion` instead.
   */
  enableFundChatbot: true,

  /**
   * Enable the Cashflow Modelling tab + full-screen workspace on the
   * relationship page (docs/specs/cashflow-modelling-tab-prd.md). When
   * off, the relationship Overview card keeps its inline ScenarioControls
   * (the pre-workspace behaviour) and the tab/route are hidden — the
   * rollback path for the workspace rollout.
   */
  cashflowWorkspace: true,
} as const;

export type FeatureFlags = typeof featureFlags;
